import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface CheckIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const CheckIcon: React.FC<CheckIconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" {...props}>
      <Path
        d="M16 3.82394L5.55368 15.5L0 8.1346L1.2879 7.8371L5.5805 10.9842L14.74 2.5L16 3.82394Z"
        strokeLinecap="round"
        fill={colors[color]}
      />
    </Svg>
  );
};
